import * as angular from "angular";
import {IController} from 'angular';
import {CustomerType} from "../../angular/types/customer-type.type";
import {Address} from "../../../addresses/models/address.model";
import * as _ from "lodash";

export class CustomerSelectItemComponent implements IController {

  customer: any;
  public customerType: typeof CustomerType = CustomerType;
  public address: Address

  constructor() {
  }

  $onInit() {
    this.address = _.find(this.customer?.addresses, (address) => {
      return address.id === this.customer.defaultAddressId;
    })
    if (!this.address) {
      this.address = _.get(this.customer, 'addresses[0]');
    }
  };

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.customer && !changes.customer.isFirstChange()) {
      this.$onInit()
    }
  }


}

angular
  .module('bringoz.admin.customers')
  .component('customerSelectItem', {
    bindings: {
      customer: '<',
      isExcluded: '<?'
    },
    template: require('./customer-select-item.html').default,
    controller: CustomerSelectItemComponent
  });
